import {BaseModuleProps} from "../../../infrastructure/models/props/base-module-props";
import {CompetitionsSliderWidgetController} from "../competitions-slider-widget.controller";

export class CompetitionsSliderWidgetProps extends BaseModuleProps {
  controller: CompetitionsSliderWidgetController;
  sportIds :Array<Number>;
  competitionsIds: Array<Number>;
  competitorIds: Array<Number>;
  showOdds: Boolean;
}
